




























































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import moment from "moment";
import { appModule } from "@/store/modules/app";
import { storeDokter } from "@/store/modules/dokter";
import { storePerawat } from "@/store/modules/perawat";
import AskeperPerioperatifStore from "@/store/modules/AskeperPerioperatifStore";
import AskeperPerioperatifService from "@/services/AskeperPerioperatifService";
import { AskeperPerioperatifInterface, emptyAskeperContent } from "@/types/askeper_perioperatif";
import AskeperProgressStepper from "@/components/AskeperPerioperatif/AskeperProgressStepper.vue";
import NandaDiagnosaChecklist from "@/components/AskeperPerioperatif/NandaDiagnosaChecklist.vue";
import NicIntervensiChecklist from "@/components/AskeperPerioperatif/NicIntervensiChecklist.vue";
import ImplPreOperasiChecklist from "@/components/AskeperPerioperatif/ImplPreOperasiChecklist.vue";
import ImplIntraOperasiChecklist from "@/components/AskeperPerioperatif/ImplIntraOperasiChecklist.vue";
import ImplPostOperasiChecklist from "@/components/AskeperPerioperatif/ImplPostOperasiChecklist.vue";
import EvaluasiKeperawatanCard from "@/components/AskeperPerioperatif/EvaluasiKeperawatanCard.vue";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";

@Component({
  components: {
    AskeperProgressStepper,
    NandaDiagnosaChecklist,
    NicIntervensiChecklist,
    ImplPreOperasiChecklist,
    ImplIntraOperasiChecklist,
    ImplPostOperasiChecklist,
    EvaluasiKeperawatanCard,
    CardModalTtd
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class AskeperPerioperatifPage extends Vue {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  step = 1;
  isNew = true;
  isEditing = false;
  saving = false;
  removing = false;

  formData: Partial<AskeperPerioperatifInterface> = {};
  content = emptyAskeperContent();

  // Sign
  modalTtd = false;
  signPhase: "pre" | "intra" | "post" = "pre";

  tujuanItems = [
    { key: "tingkat_ansietas_menurun", label: "Tingkat Ansietas Menurun (L.09093)" },
    { key: "tingkat_nyeri_menurun", label: "Tingkat Nyeri Menurun (L.08066)" },
    { key: "tingkat_infeksi_terkontrol", label: "Tingkat Infeksi Terkontrol (L.14137)" },
    { key: "tingkat_cedera_terkontrol", label: "Tingkat Cedera Terkontrol (L.14136)" },
    { key: "tingkat_jatuh_menurun", label: "Tingkat Jatuh Menurun (L.14138)" },
    { key: "tingkat_aspirasi_terkontrol", label: "Tingkat Aspirasi Terkontrol (L.01006)" },
    { key: "tingkat_perdarahan_menurun", label: "Tingkat Perdarahan Menurun (L.02017)" },
    { key: "tingkat_syok_terkontrol", label: "Tingkat Syok Terkontrol (L.05047)" },
    { key: "termoregulasi_meningkat", label: "Termoregulasi Meningkat (L.14134)" }
  ];

  mounted() {
    this.getByRegister();
  }

  get loading() {
    return AskeperPerioperatifStore.loading;
  }

  get dataList(): AskeperPerioperatifInterface[] {
    return AskeperPerioperatifStore.dataList;
  }

  get listDokter() {
    return storeDokter.list || [];
  }

  get listPerawat() {
    return storePerawat.listKaryawan || [];
  }

  get isPreLocked(): boolean {
    return !!this.formData.pre_signed_at;
  }

  get isIntraLocked(): boolean {
    return !!this.formData.intra_signed_at;
  }

  get isPostLocked(): boolean {
    return !!this.formData.post_signed_at;
  }

  get progressPercent(): number {
    let total = 0;
    let checked = 0;
    const countBooleans = (obj: Record<string, any>) => {
      for (const key of Object.keys(obj)) {
        if (typeof obj[key] === "boolean") {
          total++;
          if (obj[key]) checked++;
        }
      }
    };
    countBooleans(this.content.impl_pre_operasi || {});
    countBooleans(this.content.impl_intra_operasi || {});
    countBooleans(this.content.impl_post_operasi || {});
    return total > 0 ? Math.round((checked / total) * 100) : 0;
  }

  isFullySigned(item: AskeperPerioperatifInterface): boolean {
    return !!(item.pre_signed_at && item.intra_signed_at && item.post_signed_at);
  }

  bisaHapus(item: AskeperPerioperatifInterface): boolean {
    return !alasanTtdMengunciHapus(
      item.creator_user_id,
      [
        { ditandatangani: item.pre_signed_at, penandaTanganId: item.perawat_pre_user_id },
        { ditandatangani: item.intra_signed_at, penandaTanganId: item.perawat_intra_user_id },
        { ditandatangani: item.post_signed_at, penandaTanganId: item.perawat_post_user_id }
      ],
      userModule.user?.id
    );
  }

  formatDate(dateStr: string | null): string {
    if (!dateStr) return "-";
    return moment(dateStr).format("DD-MM-YYYY HH:mm");
  }

  async getByRegister() {
    await AskeperPerioperatifStore.fetchByRegister(this.register);
  }

  addNew() {
    this.formData = {};
    this.content = emptyAskeperContent();
    this.isNew = true;
    this.isEditing = true;
    this.step = 1;
  }

  startEdit(item: AskeperPerioperatifInterface) {
    this.formData = JSON.parse(JSON.stringify(item));
    const defaultContent = emptyAskeperContent();
    this.content = this.deepMerge(defaultContent, item.content || {});
    this.isNew = false;
    this.isEditing = true;
    this.step = 1;
  }

  cancelForm() {
    this.isEditing = false;
    this.formData = {};
    this.content = emptyAskeperContent();
  }

  deepMerge(target: any, source: any): any {
    const result = { ...target };
    for (const key of Object.keys(source)) {
      if (source[key] && typeof source[key] === "object" && !Array.isArray(source[key])) {
        result[key] = this.deepMerge(target[key] || {}, source[key]);
      } else {
        result[key] = source[key];
      }
    }
    return result;
  }

  async save() {
    this.saving = true;
    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        laporan_operasi_id: this.formData.laporan_operasi_id || null,
        content: this.content
      };

      if (this.isNew) {
        const resp = await AskeperPerioperatifService.create(payload);
        if (resp.data?.status === "1") {
          appModule.NoticeDelay("Berhasil menyimpan Askep Perioperatif");
          this.formData = resp.data.data;
          this.isNew = false;
          this.getByRegister();
        }
      } else {
        const resp = await AskeperPerioperatifService.update(this.formData.id!, payload);
        if (resp.data?.status === "1") {
          appModule.NoticeDelay("Berhasil mengupdate Askep Perioperatif");
          this.formData = resp.data.data;
          this.getByRegister();
        }
      }
    } finally {
      this.saving = false;
    }
  }

  async remove(item: AskeperPerioperatifInterface) {
    if (!this.bisaHapus(item)) return;
    const q = confirm("Anda yakin akan menghapus data Askep Perioperatif ini?");
    if (!q || this.removing) return;
    this.removing = true;
    try {
      await AskeperPerioperatifService.destroy(item.id);
      appModule.NoticeDelay("Berhasil menghapus Askep Perioperatif");
      this.getByRegister();
    } finally {
      this.removing = false;
    }
  }

  printPdf(id: number) {
    AskeperPerioperatifService.printPdf(id);
  }

  openSignDialog(phase: "pre" | "intra" | "post") {
    this.signPhase = phase;
    this.modalTtd = true;
  }

  async confirmSign(password: string) {
    if (!this.formData.id) return;
    try {
      let resp;
      if (this.signPhase === "pre") {
        resp = await AskeperPerioperatifStore.signPre({ id: this.formData.id, data: { password } });
      } else if (this.signPhase === "intra") {
        resp = await AskeperPerioperatifStore.signIntra({ id: this.formData.id, data: { password } });
      } else {
        resp = await AskeperPerioperatifStore.signPost({ id: this.formData.id, data: { password } });
      }

      if (resp.data?.status === "1") {
        this.modalTtd = false;
        const phaseLabel = { pre: "Pre-Op", intra: "Intra-Op", post: "Post-Op" }[this.signPhase];
        appModule.NoticeDelay(`Fase ${phaseLabel} berhasil ditandatangani`);
        this.formData = resp.data.data;
        this.getByRegister();
      } else {
        appModule.addMsgTtd(resp.data?.message || "Gagal tanda tangan");
      }
    } catch {
      // handled by service
    }
  }
}
